import React from 'react';
import PropTypes from 'prop-types';
import { branch, renderNothing } from 'recompose';

// Using HOC to conditional rendering
const loading = isLoading => branch(
  isLoading,
  renderNothing,
);

const enhance = loading(
  props => !(props.location && props.title),
);

const Header = enhance(({ title, location }) => {
  return (
    <div className="header">
      <p className="header__title">{title}</p>
      <p className="header__location">{location}</p>
    </div>
  );
});

const propTypes = {
  title: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
};

const defaultProps = {
  location: '',
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
